export function getApprovalLink(pin: string) {
  // TO DO - Change Link to Production URL
  return `${window.location.protocol}//${window.location.hostname}/#approve=${pin}`;
}
